export const homeCategories = [
  {
    categoryId: 'laptops',
    section: 'ELECTRIC_CATEGORIES',
    parentCategoryId: "electronics_laptop",
    name: 'Laptops',
    image: 'https://cdn.mos.cms.futurecdn.net/jGHehERQq4fhNFNTvZAhE9-320-80.png',
  },
  {
    categoryId: 'electronics_smartphones',
    section: 'ELECTRIC_CATEGORIES',
    parentCategoryId: "electronics_mobiles_tablets",
    name: 'Mobiles',
    image: 'https://images.samsung.com/is/image/samsung/p6pim/bd/sm-m556blgdbng/gallery/bd-galaxy-m55-5g-sm-m556-sm-m556blgdbng-thumb-542626587?$344_344_PNG$',
  },
  {
    categoryId: 'electronics_headphones',
    section: 'ELECTRIC_CATEGORIES',
    parentCategoryId: "electronics_mobiles_accessories",
    name: 'Headphones',
    image: 'https://www.gonoise.com/cdn/shop/files/1_2807dbd9-3951-481c-9e9a-61af0420cd37.webp?v=1720759165',
  },
  {
    categoryId: 'electronics_smart_watches',
    section: 'ELECTRIC_CATEGORIES',
    parentCategoryId: "electronics_mobiles_accessories",
    name: 'Smart Watches',
    image: 'https://images.samsung.com/is/image/samsung/p6pim/fi/sm-r861nzkaeub/gallery/fi-galaxy-watch-fe-r861-sm-r861nzkaeub-542552173?$650_519_PNG$',
  },
  {
    categoryId: 'electronics_speakers',
    section: 'ELECTRIC_CATEGORIES',
    parentCategoryId: "electronics_mobiles_accessories",
    name: 'Speakers',
    image: 'https://www.sencor.com/getmedia/6770caad-d0be-4d0d-b5f0-01bbc4c1c555/35059169.jpg.aspx?width=2100&height=2100&ext=.jpg',
  },
  {
    categoryId: 'electronics_dslr_cameras',
    section: 'ELECTRIC_CATEGORIES',
    parentCategoryId: "electronics_cameras",
    name: 'DSLR Cameras',
    image: 'https://in.canon/media/image/2024/07/17/3d47abeaf9574a9ba9401c6ff2ca7bb1_EOS+R5+Mark+II+%26+RF24-105mm+f4L+IS+USM+Front+Slant.png',
  },
  {
    categoryId: 'electronics_oled_tvs',
    section: 'ELECTRIC_CATEGORIES',
    parentCategoryId: "electronics_televisions",
    name: 'OLED TVs',
    image: 'https://images.samsung.com/is/image/samsung/africa-en-fhd-t5300-ua40t5300auxly-frontblack-243705836?$650_519_PNG$',
  },
  {
    categoryId: "women_tops_t_shirts",
    parentCategoryId: "women_western_wear",
    section: "GRID",
    name: "Women's Shirts",
    image: "https://images.pexels.com/photos/760739/pexels-photo-760739.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
  },
  {
    categoryId: "men_formal_shoes",
    parentCategoryId: "men_footwear",
    section: "GRID",
    name: "Formal Shoes",
    image: "https://images.pexels.com/photos/186035/pexels-photo-186035.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
  },
  {
    categoryId: "men_casual_shoes",
    parentCategoryId: "men_footwear",
    section: "GRID",
    name: "Casual Wear",
    image: "https://images.pexels.com/photos/164486/pexels-photo-164486.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
  },
  {
    categoryId: "women_jewelry",
    parentCategoryId: "women_accessories",
    section: "GRID",
    name: "Fashion Accessories",
    image: "https://images.pexels.com/photos/93394/pexels-photo-93394.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
  },
  {
    categoryId: "women_heels",
    parentCategoryId: "women_footwear",
    section: "GRID",
    name: "Men's Shoes",
    image: "https://images.pexels.com/photos/298863/pexels-photo-298863.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
  },
  {
    categoryId: "men_jackets_sweatshirts",
    parentCategoryId: "men_personal_care_grooming",
    section: "GRID",
    name: "Jackets & Sweatshirts",
    image: "https://images.pexels.com/photos/6232857/pexels-photo-6232857.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    name: "Home Décor",
    categoryId: "furniture_tv_units",
    parentCategoryId: "furniture_living_room",
    section: "SHOP_BY_CATEGORIES",
    image: "https://images.unsplash.com/photo-1513161455079-7dc1de15ef3e?q=80&w=2188&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Kitchen & Table",
    categoryId: "furniture_dining_tables",
    parentCategoryId: "furniture_dining_room",
    section: "SHOP_BY_CATEGORIES",
    image: "https://images.unsplash.com/photo-1600585152220-90363fe7e115?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Sports & Active Wear",
    categoryId: "women_sports_active_wear",
    parentCategoryId: "women",
    section: "SHOP_BY_CATEGORIES",
    image: "https://cdn.pixabay.com/photo/2022/10/22/12/31/woman-7539138_1280.jpg",
  },
  {
    name: "Lingerie Sleepwear",
    categoryId: "women_lingerie_sleepwear",
    parentCategoryId: "women",
    section: "SHOP_BY_CATEGORIES",
    image: "https://images.unsplash.com/photo-1561375958-669d8413fa06?q=80&w=2130&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Women Boots",
    categoryId: "women_boots",
    parentCategoryId: "women_footwear",
    section: "SHOP_BY_CATEGORIES",
    image: "https://images.unsplash.com/photo-1621996659490-3275b4d0d951?q=80&w=2130&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Dresses",
    categoryId: "women_dresses",
    parentCategoryId: "women_western_wear",
    section: "SHOP_BY_CATEGORIES",
    image: "https://www.mystore.in/s/62ea2c599d1398fa16dbae0a/64b16448567dbca9e9ed6584/1-800x800.png",
  },
  {
    name: "Men's Casual Shirts",
    categoryId: "men_casual_shirts",
    parentCategoryId: "men_topwear",
    section: "SHOP_BY_CATEGORIES",
    image: "https://images.unsplash.com/photo-1503443207922-dff7d543fd0e?q=80&w=2127&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Men's Formal Shirt",
    categoryId: "men_formal_shirts",
    parentCategoryId: "men_topwear",
    section: "SHOP_BY_CATEGORIES",
    image: "https://images.unsplash.com/photo-1508243771214-6e95d137426b?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Men's Shorts",
    categoryId: "men_shorts",
    parentCategoryId: "men_bottomwear",
    section: "SHOP_BY_CATEGORIES",
    image: "https://www.industrie.com.au/cdn/shop/files/NEW_ARRIVALS_2c218b8b-190c-4f2c-adb6-523b67ce3075.png?v=1737002657&width=2000",
  },
  {
    name: "Women's Belt",
    categoryId: "women_belts",
    parentCategoryId: "women_accessories",
    section: "SHOP_BY_CATEGORIES",
    image: "https://black-brown.com/cdn/shop/collections/Naomi_black.jpg?v=1675875745",
  },
  {
    name: "Women Jeans",
    categoryId: "women_jeans",
    parentCategoryId: "women_western_wear",
    section: "DEALS",
    image: "https://plus.unsplash.com/premium_photo-1665664652383-2308d742943c?q=80&w=2128&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Women Skirts",
    categoryId: "women_skirts",
    parentCategoryId: "women_western_wear",
    section: "DEALS",
    image: "https://images.unsplash.com/photo-1568467020752-b08fbd48e878?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Men T-Shirts",
    categoryId: "men_tshirts",
    parentCategoryId: "men_topwear",
    section: "DEALS",
    image: "https://images.unsplash.com/photo-1553859943-a02c5418b798?q=80&w=2128&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Men Suits",
    categoryId: "men_suits",
    parentCategoryId: "men_topwear",
    section: "DEALS",
    image: "https://images.pexels.com/photos/1342609/pexels-photo-1342609.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    name: "Women Jackets",
    categoryId: "women_jackets",
    parentCategoryId: "women_topwear",
    section: "DEALS",
    image: "https://images.pexels.com/photos/3772506/pexels-photo-3772506.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
  },
  {
    name: "Men Sneakers",
    categoryId: "men_sneakers",
    parentCategoryId: "men_footwear",
    section: "DEALS",
    image: "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
  },
  {
    name: "Men Sweaters",
    categoryId: "men_sweaters",
    parentCategoryId: "men_topwear",
    section: "DEALS",
    image: "https://images.unsplash.com/photo-1511401677968-feade623d58d?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Women Crop Tops",
    categoryId: "women_crop_tops",
    parentCategoryId: "women_topwear",
    section: "DEALS",
    image: "https://images.unsplash.com/photo-1603217040208-56131869e0e9?q=80&w=2235&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Men Watches",
    categoryId: "men_watches",
    parentCategoryId: "men_personal_care_grooming",
    section: "DEALS",
    image: "https://images.unsplash.com/photo-1662724174411-06358407f6c1?q=80&w=2225&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Women Bags",
    categoryId: "women_bags",
    parentCategoryId: "women_accessories",
    section: "DEALS",
    image: "https://plus.unsplash.com/premium_photo-1673758910906-3917c348ba73?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    name: "Men Sunglasses",
    categoryId: "men_sunglasses",
    parentCategoryId: "men_personal_care_grooming",
    section: "DEALS",
    image: "https://images.unsplash.com/photo-1602024247180-7b48397a8dfa?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];
